import localeDatasetAdapter, {
  Country,
  getCountryByKey,
  getCountryByShortKey,
} from '@wix/wixstores-locale-dataset-adapter';
import {AddressModel} from '../models/checkout/Address.model';

export const isSubdivisionValidForCountry = (address?: AddressModel): boolean => {
  const country: Country = getCountryFromLocaleDataset(address?.country ?? '');

  if (!country?.subdivisions) {
    return true;
  }

  return isSubdivisionInCountry(country, address?.subdivision);
};

function isSubdivisionInCountry(country: Country, subdivisionKey: string = '') {
  const fullSubdivisionKey = localeDatasetAdapter.mapReplacedSubdivision(subdivisionKey, country.key);
  const shortSubdivisionKey = fullSubdivisionKey.substring(fullSubdivisionKey.indexOf('-') + 1);
  return !!country?.subdivisions?.list?.some((subdivision) => subdivision.key === shortSubdivisionKey);
}

export function getSubdivisionName(countryKey?: string, subdivisionKey?: string): string | undefined {
  if (!countryKey || !subdivisionKey) {
    return;
  }
  const key = localeDatasetAdapter.mapReplacedSubdivision(subdivisionKey, countryKey);
  const shortSubdivisionKey = key.substring(key.indexOf('-') + 1);
  return localeDatasetAdapter.getStateByKey(countryKey, shortSubdivisionKey)?.displayName;
}

export function getCountryName(countryKey?: string): string | undefined {
  return countryKey
    ? localeDatasetAdapter.getCountryByShortKey(countryKey)?.displayName
    : /* istanbul ignore next */ undefined;
}

export const getCountryFromLocaleDataset = (country: string): Country => {
  return getCountryByShortKey(country, {
    deprecationTimestamps: [],
  });
};

export const getCountryShortKey = (country: string) => getCountryByKey(country).shortKey;

export const getFullSubdivisionCode = (country: string, subdivision: string) => {
  const shortKeyCountry = getCountryShortKey(country);
  return shortKeyCountry && !subdivision.includes('-')
    ? `${shortKeyCountry}-${subdivision}`
    : /* istanbul ignore next */ subdivision;
};
